/* eslint-disable */
export default function hotReloadPreserve<T>(instance: T, key: string, members: (keyof T)[]) {
  if (process.env.VUE_APP_MODE !== "development") {
    return;
  }

  let preserved = (window["jyreHotReloadPreserve"] = window["jyreHotReloadPreserve"] || {});

  function go() {
    setTimeout(() => go(), 100);
    for (let member of members) {
      preserved[key]!.data[member] = preserved[key]!.instance[member];
    }
  }

  preserved[key] as { instance: T; data: Partial<T> } | undefined;
  if (!preserved[key]) {
    preserved[key] = { instance, data: {} };
    go();
  } else {
    preserved[key].instance = instance;
    for (let member of members) {
      instance[member] = preserved[key].data[member] as any;
    }
  }
}
